import { pipe } from 'lodash/fp'
import { AiClient, NewsletterSectionGenerationPayload } from 'api/clients/AiClient'
import {
  removeBulletListPrefixes,
  removeNumberedListPrefixes,
  removeSurroundingQuotes,
  trim,
} from 'components/Wizards/sanitisers'

export const generateNewsletterSections = async ({
  payload,
  signal,
}: {
  payload: NewsletterSectionGenerationPayload
  signal?: AbortSignal
}) => {
  const sectionsResponse = await AiClient.generateNewsletterSections({ payload, signal })

  return sectionsResponse.split(/\n/).map(sanitise).filter(Boolean).slice(0, 5)
}

const sanitise = (str: string) =>
  pipe(trim, removeNumberedListPrefixes, removeBulletListPrefixes, removeSurroundingQuotes)(str)
